import { getConfigField } from "@linkfluence/konf";

export function useFeatures() {
  return getConfigField("features", {});
}
